import { render } from "./StartScreen.vue?vue&type=template&id=a53703de&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"

import "./StartScreen.vue?vue&type=style&index=0&id=a53703de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53703de"]])

export default __exports__